import { IDateInput } from './types';
import moment from 'moment';
import { INTERNAL_DATE_FORMAT } from '../../../../config/constants';
import { freeze } from '@reduxjs/toolkit';

// the date will be overwritten later when either config or analysis is loaded,
// just specifying a valid date so we don't chase weird bugs when dates are
// invalid (e.g. empty) string
const defaultDate = moment().format(INTERNAL_DATE_FORMAT);

export const defaultDateInput = freeze<IDateInput>(
  {
    startDate: defaultDate,
    endDate: defaultDate,
    datePicker: {
      __typename: 'DatePickerFixed',
      start: defaultDate,
      end: defaultDate,
    },
  },
  true,
);
